import React from 'react'
import { Section1Lists } from './components/Section1Lists'
import { Section1 } from './components/Section1'
import { Section2 } from './components/Section2'
import { Section3 } from './components/Section3'
import { Section4 } from './components/Section4'
import { Section5 } from './components/Section5'
import { Section6 } from './components/Section6'
import { Section7 } from './components/Section7'
import { Section8 } from './components/Section8'
import { Section9 } from 'pages/our-story/components/Section9'
import { Section10 } from 'pages/our-story/components/Section10'
import { Section11 } from 'pages/our-story/components/Section11'

export const sectionTitleTextStyles =
  'text-lg font-bold text-[#101828] leading-6 tracking-[0.4px] lg:text-[24px] 3xl:text-[32px] 3xl:leading-normal'

const OurStoryPage = () => {
  return (
    <>
      <div className='flex flex-col space-y-20 bg-[linear-gradient(180deg,_rgba(210,246,255,0.20)_0%,_rgba(255,255,255,0.20)_100%)] p-10'>
        <Section1 />
        <Section1Lists />
        <Section2 />
      </div>
      <Section3 />
      <div className='flex flex-col space-y-20'>
        <Section4 />
        <Section5 />
        <Section6 />
        <Section7 />
        <div className='px-5 !-mt-20 flex justify-center items-center'>
          <Section8 />
        </div>
      </div>
      <div className='lg:py-20 2xl:py-52 3xl:py-40'>
        <Section9 />
        <Section10 />
      </div>
      <div className='mb-30 3xl:mb-80'>
        <Section11 />
      </div>
    </>
  )
}

export default OurStoryPage
